// src/pages/PrivacyPage.tsx
import React from 'react';
import LegalDocumentPage from './legal/LegalDocumentPage';

const PrivacyPage: React.FC = () => (
  <LegalDocumentPage slug="privacy-policy" fallbackTitle="Privacy Policy" />
);

export default PrivacyPage;
